import useObservabilityConfig from 'src/public/useObservabilityConfig';

import type {ProjectName} from 'src/internal/common/types';

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-observability/api/useProject
 */
export default function useProject(): ProjectName {
  return useObservabilityConfig().project;
}
